import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { detectTempo, onsetEnvelope, toMono } from './audio/analysis';
import { registerBuffer } from './audio/decode';
import { engine } from './audio/engine';
import { extractLoop, findLoopCandidates } from './audio/loops';
import { renderProject } from './audio/render';
import { analyseTrack } from './audio/trackAnalysis';
import { DEMO_KITS, makeDemoLoop, renderKit } from './lib/demo';
import { useStore } from './store/useStore';
import './index.css';

// Dev-only console handle: lets you drive the engine and DSP without the UI.
if (import.meta.env.DEV) {
  (window as unknown as Record<string, unknown>).__wavchop = {
    useStore,
    engine,
    registerBuffer,
    renderProject,
    makeDemoLoop,
    renderKit,
    DEMO_KITS,
    analyseTrack,
    findLoopCandidates,
    extractLoop,
    analyse: { toMono, onsetEnvelope, detectTempo },
  };
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
